module.exports = __webpack_public_path__ + "static/img/bg.918d973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/bg.png
// module id = 0HjA
// module chunks = 2